import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=39b2dbcc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b2dbcc')) {
      api.createRecord('39b2dbcc', component.options)
    } else {
      api.reload('39b2dbcc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=39b2dbcc&", function () {
      api.rerender('39b2dbcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Q6IZHfpWu1g/JS/comp/childrenage.vue"
export default component.exports